<template>
  <div class="detailsmain">
    <div class="con">
      <div class="bgcc"></div>
      <div class="main">
        <p><span @click="pageJumpJumpTo" style="cursor: pointer;">{{escapingSty()}}</span> > 正文</p>
        <div class="conter" v-if="details">
          <p class="title">{{ details.title }}</p>
          <div class="deta">
            <div class="txt">
              <span>{{ details.modifyTime | formatTime }}</span>
              <span>责任编辑：系统管理员</span>
            </div>
            <div class="paragraph">
              <!-- <p class="txtp">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{details.contextData}}</p> -->
              <p class="txtp" v-html="details.contextData">
              <!-- <p class="txtp" v-html="unescapeHTML(details.contextData)"> -->
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </p>
              <br />
            </div>
          </div>
        </div>
        <!-- <div class="conter">
                  <p class="title">关于近期第三方冒用“隆携小贷”名称、Logo并制作虚假APP 进行诈骗的严正声明</p>
                  <div class="deta">
                      <div class="txt">
                        <span>2020-07-18 12:12:20</span>
                        <span>责任编辑：系统管理员</span>
                      </div>
                      <div class="paragraph">
                         <p class="txtp">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近期，我们接到受害人举报，存在不法分子冒用“隆携小贷”名称、Logo，并制作虚假APP，通过电话、QQ、微信等方式分享“二维码”诱导客户下载“隆携小额贷”等相关非合规合法发布的APP进行诈骗，谋取非法利益的情况。</p>
                         <p class="txtp">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在此，我们对冒用重庆市九龙坡区隆携小额贷款股份有限公司（下称“隆携公司”）名义进行诈骗的非法行为予以强烈谴责，隆携公司已向公安机关举报上述诈骗行为，并发布如下声明：</p>
                         <p class="txtp">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在此，我们对冒用重庆市九龙坡区隆携小额贷款股份有限公司（下称“隆携公司”）名义进行诈骗的非法行为予以强烈谴责，隆携公司已向公安机关举报上述诈骗行为，并发布如下声明：</p>
                         <p class="txtp">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二、如有假冒隆携公司工作人员以推荐贷款为由通过电话、QQ、微信等方式索取费用骗取钱财的情况，请不要轻易透露自己和家人的身份证号、银行卡账户等信息，不要向来历不明的银行账户转账、汇款，谨防上当受骗。如遭遇此类情况，建议及时与我们进行核实，官方客服热线为：023-68066606。</p>
                         <p class="txtp">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三、对于因不法分子假冒隆携公司工作人员诈骗的行为遭受财产损失的情况，建议及时拨打110报警电话或前往案发地公安机关报案求助。隆携公司将积极配合相关部门对此类行为进行调查处理，并尽一切努力，协助客户维护合法权益。</p>
                         <p class="txtp">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、凡是冒用隆携小贷名义进行诈骗行为的单位或个人，隆携公司将保留追究法律责任的权利。最后，请广大客户提高警惕，谨防受骗。同时，我们对提供冒用隆携公司名义进行欺诈行为信息的朋友表示由衷感谢！</p>
                         <br>
                         <p class="txtp">特此声明!</p>
                         <br><br>
                         <p class="txt-bom">重庆市九龙坡区隆携小额贷款股份有限公司</p>
                         <br>
                         <p class="txt-bom">2020年7月18日</p>
                      </div>
                  </div>
              </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetil } from "../../../api/news";
export default {
  name: "detail",
  data() {
    return {
      id: this.$route.params.id,
      menType: this.$route.query.menType,
      details: {},
    };
  },
  created() {
    getNewsDetil({
      titleId: this.id,
    }).then((res) => {
      console.log(res);
      this.details = res.data.data;
    });
  },
  methods: {
    pageJumpJumpTo(){
      switch (this.menType) {
        case '1':
          this.$router.push('/news')
          break
        case '2':
          this.$router.push('/creditColumn')
          break
        case '3':
          this.$router.push('/antiMoneyLaundering')
          break
        case '4':
          this.$router.push('/consumerProtection')
          break
      }
    },
    escapingSty(){
      let sty = ''
      switch (this.menType) {
        case '1':
          sty = '新闻资讯'
          break
        case '2':
          sty = '征信专栏'
          break
        case '3':
          sty = '反洗钱专栏'
          break
        case '4':
          sty = '消保专栏'
          break
      }
      return sty
    },
    unescapeHTML: function (a) {
      a = "" + a;
      return a
        .replace(/</g, "<")
        .replace(/>/g, ">")
        .replace(/&/g, "&")
        .replace(/"/g, '"')
        .replace(/&apos;/g, "'")
        .replace(/&lt;/g,"<")
        .replace(/&gt;/g,">")
        .replace(/&nbsp;/g," ");
    },
  },
  filters: {
    formatTIME: (value) => {
      return moment(value).format("YYYY年MM月DD");
    },
  },
};
</script>

<style lang="scss" scoped>
.detailsmain {
  .con {
    .bgcc {
      width: 100%;
      height: 500px;
      background: url("../../../assets/新闻资讯.jpg") center center no-repeat;
      background-size: 100% 122%;
      background-position-y: -80px;
      image-rendering: -moz-crisp-edges;
      image-rendering: -o-crisp-edges;
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
      -ms-interpolation-mode: nearest-neighbor;
    }

    .main {
      padding: 20px;
      text-align: left;
      font-size: 30px;
      background-color: #fff;
      p {
        margin: 0;
      }

      .conter {
        background-color: #f2f2f2;
        padding-top: 20px;
        padding-left: 50px;
        padding-right: 50px;
        .title {
          font-size: 30px;
          color: red;
          font-weight: bold;
          text-align: center;
        }
        .deta {
          width: 1200px;
          margin: 0 auto;
          .txt {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
          }

          .paragraph {
            padding-top: 30px;
            padding-bottom: 20px;
            .txtp {
              font-size: 16px;
            }
            .txt-bom {
              font-size: 16px;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/News/Details/index.vue